import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import { UtilityService } from '../../../../core/services/utility.service';
import { from, of, Subject, concat } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { CrewTimecardService } from '../../../../pages/crew-timecard/services/crew-timecard.service';

@Component({
  selector: 'app-add-field-ticket-day',
  templateUrl: './add-field-ticket-day.component.html',
  styleUrls: ['./add-field-ticket-day.component.css'],
})
export class AddFieldTicketDayComponent implements OnInit {
  @Input() template: any;
  @Input() templateDates: any[];

  portalSettings: any;
  format: string;
  selectedValue: any;
  templateChanged: boolean;

  constructor(
    private crewTimecardService: CrewTimecardService,
    public activeModal: NgbActiveModal,
    portalSettingsService: PortalSettingsService,
    private utilityService: UtilityService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.format = this.utilityService.getDateFormat().toUpperCase();
    this.templateChanged = false;
  }

  addValue() {
    this.crewTimecardService
      .insertTemplateData(
        this.template.PostDateCrewLayoutDetailID,
        this.template.CrewTemplateID,
        this.selectedValue.FieldValue,
        this.selectedValue.FieldIdentifier
      )
      .then((response: any) => {
        if (response.success) {
          this.templateChanged = true;
          this.templateDates.every(val => {
            if (val.FieldValue == this.selectedValue.FieldValue) {
              val.IsSelected = true;
              val.CrewTemplateDataID = response.crewTemplateDataID;
              return false;
            }
            return true;
          });
          this.templateDates = _.cloneDeep(this.templateDates);
          this.selectedValue = null;
        }
      });
  }

  deleteValue(value: any) {
    this.crewTimecardService.deleteTemplateData(value.CrewTemplateDataID).then((response: any) => {
      if (response.success) {
        this.templateChanged = true;
        this.templateDates.every(val => {
          if (val.FieldValue == value.FieldValue) {
            val.IsSelected = false;
            return false;
          }
          return true;
        });
        this.templateDates = _.cloneDeep(this.templateDates);
      }
    });
  }

  closeClicked() {
    this.activeModal.close(this.templateChanged);
  }
}
